/** SSDI directory upload modules that mirror Upload Parking Yard. */
export const DIRECTORY_UPLOAD_MODULES = {
  "repo-agencies": {
    type: "repo-agencies",
    publicKind: "repo-agencies",
    title: "All India Repo/Collection Agencies Details",
    singular: "Repo/Collection Agency",
    storageKeyPrefix: "fr_repo_agencies_upload_sessions",
    sampleFileName: "repo-agencies-sample.xlsx",
    noun: "repo-agency",
  },
  "crane-services": {
    type: "crane-services",
    publicKind: "crane-services",
    title: "All India Crane/Towing Service Details",
    singular: "Crane Service",
    storageKeyPrefix: "fr_crane_services_upload_sessions",
    sampleFileName: "crane-services-sample.xlsx",
    noun: "crane-service",
  },
};
